<template>
  <CFooter>
    <div>
      <a href="https://coreui.io" target="_blank">CoreUI</a>
      <span class="ml-1">&copy; 2019 creativeLabs.</span>
    </div>
    <div class="ml-auto">
      <span class="mr-1" target="_blank">オープンクーポン株式会社</span>
    </div>
  </CFooter>
</template>

<script>
export default {
  name: 'TheFooter'
}
</script>
